module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "tableFilters",
    attrs: {
      "id": "icon-search"
    }
  }, [_c('div', {
    staticClass: "form-content-title-block filter-container"
  }, [_c('div', {
    staticClass: "filter-block filter-block-various"
  }, [_c('label', [_vm._v("Buscar por")]), _vm._v(" "), _c('div', {
    staticClass: "filter-block-content"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.filterBy),
      expression: "tableData.filterBy"
    }],
    staticClass: "form-control form-search",
    attrs: {
      "id": "select-search"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableData, "filterBy", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.cleanInput()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.filterColumns), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.name
      }
    }, [_vm._v("\n              " + _vm._s(option.label) + "\n            ")])
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.filterValue),
      expression: "tableData.filterValue"
    }],
    staticClass: "input form-control",
    attrs: {
      "id": "search-bar",
      "type": "search",
      "placeholder": "Buscar..."
    },
    domProps: {
      "value": (_vm.tableData.filterValue)
    },
    on: {
      "keyup": function($event) {
        return _vm.getUsers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tableData, "filterValue", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "filter-block filter-block-alone filter-block-ship",
    staticStyle: {
      "width": "300px"
    }
  }, [_c('label', [_vm._v("Estatus de DNI:")]), _vm._v(" "), _c('div', {
    staticClass: "filter-block-content"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.filterStatusDni),
      expression: "tableData.filterStatusDni"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableData, "filterStatusDni", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.getUsers()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Pendiente")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Esperando revisión")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Verificado")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Rechazado")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-ship"
  }, [(_vm.is_loading == false) ? _c('data-table', {
    attrs: {
      "columns": _vm.columns,
      "sortKey": _vm.sortKey,
      "sortOrders": _vm.sortOrders
    },
    on: {
      "sort": _vm.sortBy
    }
  }, [_c('tbody', {
    staticClass: "kt-datatable__body"
  }, _vm._l((_vm.users), function(user) {
    return _c('router-link', {
      key: user.id,
      attrs: {
        "to": {
          name: 'UserDetail',
          params: {
            idUser: user.id
          },
        }
      }
    }, [_c('tr', {
      staticClass: "kt-datatable__row"
    }, [_c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(user.attributes.profile.attributes.userable.client_code) + "\n                "), _c('br'), _vm._v(" "), (
      user.attributes.profile.attributes.userable.attributes.facebook_id
    ) ? _c('span', {
      staticClass: "badge badge-primary"
    }, [_vm._v("Facebook\n                ")]) : (
      user.attributes.profile.attributes.userable.attributes.gmail_id
    ) ? _c('span', {
      staticClass: "badge badge-danger"
    }, [_vm._v("Gmail")]) : _c('span', {
      staticClass: "badge badge-secondary"
    }, [_vm._v("Formulario")])])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(user.attributes.profile.attributes.userable.attributes.store_id === 1 ?
      "Sendi" :
      "Envios"))])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v("\n                " + _vm._s(user.attributes.profile.attributes.document_number ?
      user.attributes.profile.attributes.document_number :
      "sin documento")), _c('br'), _vm._v(" "), _c('ul', {
      staticClass: "listStyle"
    }, [_c('li', [_c('img', {
      attrs: {
        "src": "/static/img/dni/anterior-dni.png",
        "width": "30"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "badge badge-primary",
      class: [
        (user.attributes.profile.attributes.userable.attributes
          .document_face_state === 1 ?
          ' bg-secondary' :
          '') ||
        (user.attributes.profile.attributes.userable.attributes
          .document_face_state === 2 ?
          ' bg-warning' :
          '') ||
        (user.attributes.profile.attributes.userable.attributes
          .document_face_state === 3 ?
          ' bg-success' :
          '') ||
        (user.attributes.profile.attributes.userable.attributes
          .document_face_state === 4 ?
          ' bg-danger' :
          '') ]
    }, [(
      user.attributes.profile.attributes.userable.attributes
      .document_face_state === 1
    ) ? _c('span', [_vm._v("Pendiente")]) : _vm._e(), _vm._v(" "), (
      user.attributes.profile.attributes.userable.attributes
      .document_face_state === 2
    ) ? _c('span', [_vm._v("Esperando Revisión")]) : _vm._e(), _vm._v(" "), (
      user.attributes.profile.attributes.userable.attributes
      .document_face_state === 3
    ) ? _c('span', [_vm._v("Verificado")]) : _vm._e(), _vm._v(" "), (
      user.attributes.profile.attributes.userable.attributes
      .document_face_state === 4
    ) ? _c('span', [_vm._v("Rechazado")]) : _vm._e()])]), _vm._v(" "), _c('li', [_c('img', {
      attrs: {
        "src": "/static/img/dni/posterior-dni.png",
        "width": "30"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "badge badge-primary",
      class: [
        (user.attributes.profile.attributes.userable.attributes
          .document_seal_state === 1 ?
          ' bg-secondary' :
          '') ||
        (user.attributes.profile.attributes.userable.attributes
          .document_seal_state === 2 ?
          ' bg-warning' :
          '') ||
        (user.attributes.profile.attributes.userable.attributes
          .document_seal_state === 3 ?
          ' bg-success' :
          '') ||
        (user.attributes.profile.attributes.userable.attributes
          .document_seal_state === 4 ?
          ' bg-danger' :
          '') ]
    }, [(
      user.attributes.profile.attributes.userable.attributes
      .document_seal_state === 1
    ) ? _c('span', [_vm._v("Pendiente")]) : _vm._e(), _vm._v(" "), (
      user.attributes.profile.attributes.userable.attributes
      .document_seal_state === 2
    ) ? _c('span', [_vm._v("Esperando Revisión")]) : _vm._e(), _vm._v(" "), (
      user.attributes.profile.attributes.userable.attributes
      .document_seal_state === 3
    ) ? _c('span', [_vm._v("Verificado")]) : _vm._e(), _vm._v(" "), (
      user.attributes.profile.attributes.userable.attributes
      .document_seal_state === 4
    ) ? _c('span', [_vm._v("Rechazado")]) : _vm._e()])])])])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(user.attributes.email))])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(user.attributes.profile.attributes.name) + "\n                " + _vm._s(user.attributes.profile.attributes.surnames))])]), _vm._v(" "), _c('td', {
      staticClass: "td-table"
    }, [_c('span', {
      staticClass: "span-title"
    }, [_vm._v(_vm._s(user.attributes.profile.attributes.country_code) + "\n                " + _vm._s(user.attributes.profile.attributes.cellphone ?
      user.attributes.profile.attributes.cellphone :
      "sin teléfono"))])])])])
  }), 1)]) : _vm._e()], 1), _vm._v(" "), (_vm.is_loading == false) ? _c('pagination', {
    attrs: {
      "pagination": _vm.pagination
    },
    on: {
      "changePagination": _vm.getUsers
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36317afc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/prefab/elements/user-chart1-list.vue
// module id = 1867
// module chunks = 1